import React from 'react';
import {ArrowRight} from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function Hero() {
  const { t } = useLanguage();
  
  return (
    <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" itemScope itemType="https://schema.org/LocalBusiness">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.lumi.new/91/910c5b5a98a6181950cda036bf9e6e81.png"
          alt="Floresta de pinheiros em Portugal - Pinhacorada Silvicultura"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Content */}
      <header className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-playfair font-bold text-white mb-6 leading-tight animate-fade-in-up delay-100 text-center px-2" itemProp="name">
          <span className="text-center font-bold text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-[#F5F5F5]">PINHACORADA</span><br />
          <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#22C55E]">{t('hero.subtitle')}</span>
        </h1>
        
        <p className="max-w-2xl mx-auto text-base sm:text-lg md:text-xl text-gray-200 mb-10 font-light animate-fade-in-up delay-200 px-4" itemProp="description">{t('hero.description')}

        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up delay-300">
          <a
            href="#services"
            className="px-8 py-4 rounded-full bg-green-700 text-white font-semibold hover:bg-green-600 transition-all transform hover:scale-105 shadow-lg shadow-green-900/20 flex items-center justify-center gap-2">

            {t('hero.servicesButton')}
            <ArrowRight className="h-4 w-4" />
          </a>
          



        </div>
        
        {/* Hidden schema.org data for SEO */}
        <meta itemProp="address" content="Mortágua, Portugal" />
        <meta itemProp="email" content="pinhacorada@gmail.com" />
        <meta itemProp="telephone" content="+351967905983" />
      </header>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce text-white/50">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/70 rounded-full" />
        </div>
      </div>
    </section>);

}